import { IFilter } from "../../../../context/filters";
import { ISelectedFilterMap } from "../../../../context/selectedFilters";
import { IEntityFilterItem } from "../../BaseFilter";

export const isFilterSelected = (
  selectedFilterMap: ISelectedFilterMap,
  { entity: { slug: entitySlug } }: IEntityFilterItem,
  { slug: filterSlug }: IFilter
): boolean => {
  const selectedEntity =
    selectedFilterMap.featured[entitySlug] || selectedFilterMap.secondary[entitySlug];
  return Boolean(selectedEntity) && selectedEntity.filter.slug === filterSlug;
};
